<template>
    <div class="card">
        <div class="card-body m-2">
            <div class="row p-2">
                <div class="row align-items-center">
                    <div class="row">
                        <div class="grid-container">
                            <div class="grid-item">
                                <label>Columns</label>
                                <input type="text" class="value" value="2">
                            </div>
                            <div class="grid-item">
                                <label>Rows</label>
                                <input type="text" class="value" value="2">
                            </div>
                            <div class="grid-item">
                                <label>Cell Vertical Padding</label>
                                <input type="text" class="value" value="1px">
                            </div>
                            <div class="grid-item">
                                <label>Cell Horizontal Padding</label>
                                <input type="text" class="value" value="1px">
                            </div>
                            <div class="grid-item">
                                <label>Border Thickness</label>
                                <input type="text" class="value" value="1px">
                            </div>
                            <div class="grid-item">
                                <label>Image Sizes on Grid</label>
                                <div class="image-size-inputs">
                                    <input type="text" class="value image-width" value="300px" placeholder="L">
                                    <input type="text" class="value image-height" value="175px" placeholder="H">
                                </div>
                            </div>
                            <div class="grid-item">
                                <label>Cell BG Color</label>
                                <input type="color" class="value color-bg" value="#00a0c1">
                            </div>
                            <div class="grid-item">
                                <label>Border Color</label>
                                <input type="color" class="value color-border" value="#a3c0d1">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>



</template>

<script>

export default ({
    components: {


    },

    props: {

    },

    data() {
        return {

        }
    },

    computed: {

    },

    watch: {

    },

    created() {
        this.init()
    },

    methods: {
        init() {
            console.log("nag sulod d sa init")
        },
    },

})
</script>

<style scoped>
.options-menu {
    display: flex;
    flex-wrap: wrap;
}

.testimonial-list {
    display: flex;
    flex-wrap: wrap;
    /* gap: 0.1rem; */
    /* justify-content: stretch; */
}

.testimonial-card {
    border-radius: 9px;
    box-shadow: 0px 10px 25px 0px rgba(0, 0, 0, 0.10);
    /* margin: 0.2rem; */
    /* min-width: 300px;
      max-width: 100%; */
    /* max-width: 300px; */
    /* min-height: 350px; */
    /* display: flex; */
}

.testimonial-card .card-header {
    padding: 0;
    border-bottom: none;
    height: 80px;
    font-weight: 900;
    /* font-size: 20px; */
    color: #fff;
    /* background-color: #3880BC; */
    background-color: whitesmoke;
    border-radius: 10px 10px 0 0;
    /* text-align: center;
    line-height: 20px; */
}

.small-font-size {
    font-size: 12px;
}

.large-font-size {
    font-size: 20px;
}

.testimonial-card-no-rec {
    display: flex;
    margin: 1rem;
    justify-content: center;
}

.testimonial-card-no-rec p {
    font-weight: 900;
    font-size: 18px;
    margin: 0;
}


/* Label for products */
.label-container {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
}

.label {
    background-color: #34495e;
    color: white;
    padding: 10px 10px;
    border: none;
    border-radius: 5px;
    font-weight: bold;
}

.testimonial-button-container {
    display: flex;
    gap: 7px;
}

.cover-page-header-color {
    background-color: #3880BC;
}

.product-service-header-color {
    background-color: #F3994D;
}

.pricing-table-header-color {
    background-color: #8325B0 !important;
}

.images-header-color {
    background-color: #A63B62;
}

.testimonials-header-color {
    background-color: #00A54F;
}

.video-header-color {
    background-color: #6388A7;
}

.content-header-color {
    background-color: #68962E;
}

.acceptance-execution-header-color {
    background-color: #BC5838;
}

.organisation-table-header-color {
    background-color: #38B4BC;
}

/* for image */

.fill {
    /* background-size: cover; */
    object-fit: fill;
    /* background-position: center; */
    width: 100%;
    height: 100%;
    border-radius: 10px 10px 0 0;
}

.card-body-height {
    min-height: 130px;
}

.position-bottom {
    position: absolute;
    bottom: 0;
    width: 100%;
}


.testimonial {
    font-family: sans-serif;
    /* A simple, readable font */
    border: 1px solid #ddd;
    /* Optional: Adds a subtle border */
    padding: 20px;
    width: 180px;
    /* Adjust width as needed */
}

.testimonial-text {
    font-size: 16px;
    line-height: 1.5;
    /* Improves readability */
}

.testimonial-author {
    font-weight: bold;
    margin-top: 10px;
}

.testimonial-title {
    font-size: 14px;
    color: #00A0C1;
    /* A lighter color for the title */
}

.block-button-container {
    display: flex;
    margin-left: -3px;
    gap: 3px;
}

@media (min-width: 1900px) {

    /* Adjust breakpoint as needed */
    .block-button-container {
        gap: 6px;
        /* Larger gap for larger screens */
    }
}

/* style */
.grid-container {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 10px;
    font-family: sans-serif;
    padding: 20px;
}

.grid-item {
    border: 1px solid #ddd;
    padding: 10px;
}

.grid-item label {
    display: block;
    font-weight: bold;
    margin-bottom: 5px;
    color: #555;
}

.grid-item .value {
    padding: 8px 12px;
    border: 1px solid #ccc;
    border-radius: 4px;
    background-color: #f9f9f9;
    width: 100%;
    /* Make inputs fill the available width */
    box-sizing: border-box;
    /* Include padding in width */
}

.grid-item .color-bg,
.grid-item .color-border {
    padding: 0;
    /* Remove padding for color inputs */
    height: 36px;
    /* Adjust height as needed */
    width: 100%;
}

.image-size-inputs {
  display: flex; /* Use flexbox to arrange inputs horizontally */
  gap: 5px; /* Add some gap between the inputs */
}

.image-size-inputs input {
  flex: 1; /* Make inputs take equal width */
}
</style>